var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import cx from 'classnames';
import styles from './SvgIcon.module.css';
export var SvgIcon = function (_a) {
    var children = _a.children, titleAccess = _a.titleAccess, _b = _a.viewBox, viewBox = _b === void 0 ? '0 0 20 20' : _b, className = _a.className, rest = __rest(_a, ["children", "titleAccess", "viewBox", "className"]);
    return (React.createElement("svg", __assign({ className: cx(className, styles.svgIcon), viewBox: viewBox, focusable: "false", "aria-hidden": titleAccess ? 'false' : 'true', xmlns: "http://www.w3.org/2000/svg" }, rest),
        titleAccess && React.createElement("title", null, titleAccess),
        children));
};
//# sourceMappingURL=SvgIcon.js.map